import React, { useState } from "react";
import { Modal } from "antd";
import { connect } from "react-redux";
import moment from "moment";
import { Button, Spinner } from "../../kado/components";
import renderHTML from 'react-render-html';
import I18, { i18Get } from "../../i18";
import { AcceptTems } from "../../actions/ui";
import Tostify from '../../kado/utils/tostify';

const TermsandCondition = ({ isTermsAccepted, selAss, dispatch }) => {
    const [accepted, setAccepted] = useState(false);
    const handleSubmit = () => {
        if (accepted) {
            const payload = {
                accepted_on: moment().format('DD.MM.YYYY HH:mm'),
                terms_and_condition: [selAss.terms_content.uuid],
                assessment: selAss.uuid,
            }
            dispatch(AcceptTems(payload));
        } else {
            Tostify.showInfo(i18Get('Please accept the terms and conditions.'));
        }
    };

    return (
        <Modal
            className="finsih-modal"
            visible={selAss.terms_and_conditions}
            title= {i18Get("Terms and Conditions")}
            footer={null}
            closable={false}
            centered
            width={720}
            bodyStyle={{
                padding: "0px",
                height: "720px",
                overflow: "hidden",
                borderRadius: "24px",
            }}
        >
            <div
                style={{
                    height: "720px",
                    display: "flex",
                    flexDirection: "column",
                    background: "#fff",
                    justifyContent: "space-between",
                }}
            >
                <div
                    style={{
                        padding: "24px",
                        flex: 1,
                        overflowY: "auto",
                    }}
                >
                    <div>
                    {selAss && selAss.terms_content.terms_content.length !== 0 && renderHTML(renderHTML(selAss.terms_content.terms_content))}                        
                    </div>
                </div>
                <div
                    style={{
                        padding: "18px",
                        borderTop: "1px solid #EAEAEA",
                        background: "#fff",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "12px",
                            flexWrap: "wrap",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                minWidth: 0
                            }}
                        >
                            <label className="ant-checkbox-wrapper">
                                <span
                                    className={`ant-checkbox ${
                                        accepted
                                            ? "ant-checkbox-checked"
                                            : ""
                                    }`}
                                >
                                    <input
                                        type="checkbox"
                                        className="ant-checkbox-input"
                                        checked={accepted}
                                        onChange={(e) =>
                                            setAccepted(e.target.checked)
                                        }
                                    />

                                    <span className="ant-checkbox-inner"></span>
                                </span>
                            </label>

                            <span
                                style={{
                                    fontSize: "16px",
                                    fontWeight: "400",
                                    whiteSpace: "nowrap"
                                }}
                            >
                                {i18Get("I Accept")}
                            </span>
                        </div>
                     
                        <div
                            style={{
                                display: "flex",
                                gap: "12px",
                            }}
                        >
                            <Button
                                className={"btn-active"}
                                onClick={handleSubmit}
                                color={"green"}
                                disabled={isTermsAccepted === 'PENDING'}
                            >
                                {isTermsAccepted === 'PENDING' && <Spinner />}
                                {i18Get("Submit")}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default connect((store) => ({
    translations: store.translations,
}))(TermsandCondition);